import React, { Component } from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import {
  Metric,
  selectFormat,
  Error,
  CustomizedYAxisTick,
  CustomizedXAxisTickTimeDay,
  StandardTooltip,
} from "./../Utils/Utils.js";

import Heading from "./../Elements/Heading";

const GRADIENT = (type) =>
  ({
    daily: ["#FAA461", "#FC6D52"],
    weekly: ["#16C8DE", "#1384C8"],
    monthly: ["#11AB66", "#16DE85"],
  }[type]);

class DailyActives extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.props.data.data,
    opts: {
      type: "chart",
    },
  });

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row">
        <div className="col-12 mt-2 d-flex align-items-end">
          <div className="col-auto">
            <Heading size={6} className={"mb-1"}>
              Daily Active Users
            </Heading>
            <Metric {...data.daily_active} size={"md"} />
          </div>

          <div className="col-auto">
            <Heading size={6} className={"mb-1"}>
              Weekly Active Users
            </Heading>
            <Metric {...data.weekly_active} size={"md"} />
          </div>

          <div className="col-auto">
            <Heading size={6} className={"mb-1"}>
              Monthly Active Users
            </Heading>
            <Metric {...data.monthly_active} size={"md"} />
          </div>
        </div>

        <ResponsiveContainer height={340} width="100%">
          <AreaChart
            width={600}
            height={400}
            data={data.data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid
              stroke="#FEE5DE"
              strokeDasharray="3 3"
              vertical={false}
            />

            <Area
              type="monotone"
              dataKey="daily"
              stackId="1"
              stroke="none"
              fill="url(#gradient-daily)"
            />
            <Area
              type="monotone"
              dataKey="weekly"
              stackId="1"
              stroke="none"
              fill="url(#gradient-weekly)"
            />
            <Area
              type="monotone"
              dataKey="monthly"
              stackId="1"
              stroke="none"
              fill="url(#gradient-monthly)"
            />

            <defs>
              <linearGradient
                id="gradient-daily"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop
                  offset="5%"
                  stopColor={GRADIENT("daily")[0]}
                  stopOpacity={1}
                />
                <stop
                  offset="95%"
                  stopColor={GRADIENT("daily")[1]}
                  stopOpacity={1}
                />
              </linearGradient>
            </defs>

            <defs>
              <linearGradient
                id="gradient-weekly"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop
                  offset="5%"
                  stopColor={GRADIENT("weekly")[0]}
                  stopOpacity={1}
                />
                <stop
                  offset="95%"
                  stopColor={GRADIENT("weekly")[1]}
                  stopOpacity={1}
                />
              </linearGradient>
            </defs>

            <defs>
              <linearGradient
                id="gradient-monthly"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop
                  offset="5%"
                  stopColor={GRADIENT("monthly")[0]}
                  stopOpacity={1}
                />
                <stop
                  offset="95%"
                  stopColor={GRADIENT("monthly")[1]}
                  stopOpacity={1}
                />
              </linearGradient>
            </defs>

            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              scale="auto"
              tick={<CustomizedXAxisTickTimeDay />}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              mirror={true}
              tick={<CustomizedYAxisTick />}
            />

            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={
                <StandardTooltip
                  render={({ data }) => {
                    const payload = data(this.props);

                    if (payload !== null) {
                      const tooltip_data = payload[0].payload;

                      return (
                        <div className="standard-tooltip">
                          {tooltip_data.date && (
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Date:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {tooltip_data.date}
                              </span>
                            </header>
                          )}
                          <main className="standard-tooltip__main">
                            {Object.keys(payload)
                              .sort(
                                (a, b) => payload[b].value - payload[a].value
                              )
                              .filter((key) => payload[key].value > 0)
                              .map((key, index) => (
                                <div
                                  className="standard-tooltip__item"
                                  key={key}
                                >
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background: GRADIENT(
                                        payload[key].name
                                      )[0],
                                    }}
                                  />
                                  <span
                                    className="standard-tooltip__key"
                                    style={{
                                      color: payload[key].color,
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {payload[key].dataKey}{" "}
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat("number", payload[key].value)}
                                  </span>
                                </div>
                              ))}
                          </main>
                        </div>
                      );
                    }
                  }}
                />
              }
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default DailyActives;
